export const defaultProactiveChatPaneStartButtonHoveredStyles = {
  backgroundColor: "",
  color: ""
};